// This component replaces slate's default placeholder rendering,
// which just checks if the strings within the editor are empty,
// ignoring if there are any block elements present.

import React from 'react';
import EditorUtils from '../AhaEditorUtils/EditorUtils';
import type { RenderPlaceholderProps } from 'slate-react';
import type { AhaSlateEditor } from '../types/aha-editor';
import styles from './AhaEditorV2.module.css';

interface PlaceholderProps extends RenderPlaceholderProps {
  editor: AhaSlateEditor;
  placeholderChildren?: React.ReactNode;
}

const Placeholder: React.FC<PlaceholderProps> = ({
  editor,
  attributes,
  placeholderChildren,
  children,
}) => {
  if (!EditorUtils.isEmpty(editor)) {
    return null;
  }

  if (placeholderChildren) {
    return (
      <span className={styles.placeholder} {...attributes}>
        {placeholderChildren}
      </span>
    );
  } else {
    return (
      <span className={styles.placeholder} {...attributes}>
        {children}
      </span>
    );
  }
};
export default Placeholder;
